import { useState, useEffect, useRef } from "react";


function ClipboardButton({
  content, icon, tooltip
}) {
  const [isCopied, setIsCopied] = useState(false);

  async function shareText(newClip) {
    try {
      await navigator.share({ title: "CRM", text: newClip });
      console.log("Share success");

      // resultPara.textContent = "MDN shared successfully";
    } catch (err) {
      console.log("Share error");
      console.log(err);

      // resultPara.textContent = `Error: ${err}`;
    }

    /* navigator.clipboard.writeText(newClip).then(
      () => {
        // clipboard successfully set
      },
      () => {
        // clipboard write failed
      },
    ); */
  }

  function updateClipboard(e,newClip) {
    
    e.stopPropagation();
    e.preventDefault()

    navigator.clipboard.writeText(newClip).then(
      () => {
        // clipboard successfully set
        setIsCopied(true)
        setTimeout(()=>{
          setIsCopied(false)
        },[300])
      },
      () => {
        // clipboard write failed
      },
    );
  }


  
    
  return (
    
            <button
              className="share-button"
              // style={{boxShadow: isCopied?"0px 0px 5px 5px green":"0px 0px 0px 0px transparent"}}
              style={isCopied?{transform: "translate(0px, -5px) scale(1.2)"}:{}}
              title={tooltip}
              onClick={(e) =>
                updateClipboard(e,
                  content
                )
              }
            >
              <img src={icon}  />
            </button>
         
  );
}

export default ClipboardButton;
